import Toast from "components/toast";
import { _goToRoot } from "routers/helper";

export const onAddReminderRes = (res: { data: any }) => {
  Toast.success({ message: res.data.message });
  _goToRoot();
};

export const onEditReminderRes = (res: { data: any }) => {
  Toast.success({ message: res.data.message });
};

export const onDeleteReminderRes = onEditReminderRes;
